export enum ÉTAT_GROUPE {
  A_FAIRE = 'ÀFaire',
  A_VALIDER = 'ÀValider',
  VALIDE = 'Validé',
  REJETE = 'Rejeté',
}

export const étatGroupeOrdre: Record<ÉTAT_GROUPE, number> = {
  [ÉTAT_GROUPE.REJETE]: 0,
  [ÉTAT_GROUPE.A_FAIRE]: 1,
  [ÉTAT_GROUPE.A_VALIDER]: 2,
  [ÉTAT_GROUPE.VALIDE]: 3,
};
